import { defineAction } from '~/prix'
import migrationMigrateOlapAction from './migrationMigrateOlap.action.json' with { type: 'json' }
import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'

const migrationMigrateOlapDefinition = defineAction({
  ...migrationMigrateOlapAction,
  input: z.object({}),
  output: z.object({
    results: z.array(
      z.object({
        timestamp: z.number(),
        result: enumerated({ success: 'Sucesso', skip: 'Já executada' }),
      }),
    ),
  }),
})

export default migrationMigrateOlapDefinition
